var _path, _path2, _path3, _path4, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorder(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 436,
    height: 601,
    viewBox: "0 0 436 601",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.888 29.3221L24.786 36.0675L34.1746 573.467L420.277 566.721L410.888 29.3221ZM21.2839 31.3685L30.8388 578.285L423.779 571.42L414.224 24.5037L21.2839 31.3685Z",
    fill: "url(#paint0_linear_border)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.696 2.28224L12.0352 9.10726L21.4999 550.863L412.161 544.038L402.696 2.28224ZM10.8679 7.54674L20.3879 552.464L413.328 545.599L403.808 0.6819L10.8679 7.54674Z",
    fill: "url(#paint1_linear_border)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.357 39.8924L35.6905 46.7001L45.1552 588.456L434.822 581.648L425.357 39.8924ZM34.5261 45.1395L44.0461 590.056L435.986 583.209L426.466 38.2921L34.5261 45.1395Z",
    fill: "url(#paint2_linear_border)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.538 50.4845L1.87115 57.2921L11.3359 599.048L401.003 592.24L391.538 50.4845ZM0.706787 55.7316L10.2267 600.648L402.167 593.801L392.647 48.8842L0.706787 55.7316Z",
    fill: "url(#paint3_linear_border)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_border",
    x1: 5.49417,
    y1: 328.215,
    x2: 397.405,
    y2: 321.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_border",
    x1: 5.49417,
    y1: 328.215,
    x2: 397.405,
    y2: 321.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_border",
    x1: 5.49417,
    y1: 328.215,
    x2: 397.405,
    y2: 321.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_border",
    x1: 5.49417,
    y1: 328.215,
    x2: 397.405,
    y2: 321.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.4aa4a0de.svg";
export { ForwardRef as ReactComponent };